import type { QuestionImage } from '@api/instant_survey/types';

/**
 * Resolve the displayable URL for a concept image. A freshly uploaded image only has the local
 * `previewUrl` blob until the next save round-trip returns a `cdnUrl`.
 * @param image
 * @returns the first usable URL, or null when the concept has no image
 */
export const getConceptImageUrl = (image?: null | QuestionImage): null | string =>
  image?.cdnUrl || image?.previewUrl || image?.url || null;
